<template>
  <div class="rol">
    <h3>{{ $t("admin.bussiness.programsAdmin") }}</h3>
    <div role="group" class="configuracion">
      <b-row class="mb-4 align-items-center text-align-end">
        <b-col cols="5"></b-col>
        <b-col>
          <b-input-group size="md">
            <b-form-input
              id="filter-input-bussiness"
              v-model="filterBussiness"
              type="search"
              class="custom-input"
              :placeholder="this.$i18n.t('admin.bussiness.searchPrograms')"
            >
            </b-form-input>
          </b-input-group>
          <b-icon
            icon="search"
            aria-hidden="true"
            flip-h
            class="input__search__icon"
          ></b-icon>
        </b-col>
        <b-col>
          <b-button
            variant="outline-primary"
            class="button btn-blue-dark ml-0"
            @click="newProgramConfiguration"
            v-if="configRol.administrador.pestana.adminSucursales.acciones.crear"
          >
            {{ $t("admin.role.createConf") }}
          </b-button>
        </b-col>
      </b-row>
      <template
        v-if="configRol.administrador.pestana.adminSucursales.acciones.listar"
      >
        <b-table
          :items="itemsBussiness"
          :fields="fields"
          :filter="filterBussiness"
          :filter-included-fields="filterOn"
          class="mt-5"
          show-empty
          thead-tr-class="headerClass"
          :busy="isLoadingBussinessList"
        >
          <template #cell(actions)="row">
            <b-row>
              <b-button
                size="sm"
                class="mr-2 bg-success"
                @click="editConfigProgram(row.item)"
                v-if="configRol.administrador.pestana.adminSucursales.acciones.editar"
              >
                {{ $t("admin.role.edit") }}
              </b-button>
              <b-button
                size="sm"
                class="mr-2"
                @click="cloneConfigPrograms(row.item)"
                v-if="configRol.administrador.pestana.adminSucursales.acciones.clonar"
              >
                {{ $t("admin.role.clone") }}
              </b-button>
              <b-button
                size="sm"
                class="mr-2 bg-danger"
                @click="deleteConfigProgram(row.item._id)"
                v-if="configRol.administrador.pestana.adminSucursales.acciones.eliminar"
              >
                {{ $t("admin.role.delete") }}
              </b-button>
              <b-form-checkbox
                v-model="row.item.estado"
                @change="changeStatus(row.item)"
                name="check-button"
                switch
                v-if="configRol.administrador.pestana.adminSucursales.acciones.editar"
              >
            </b-form-checkbox>
            </b-row>
          </template>
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
      </template>
      <template v-else>
        <b-alert show dismissible>
          <p>
            {{ $t("admin.bussiness.msgUnable") }}
          </p>
        </b-alert>
      </template>
    </div>
    <!-- MODAL CONFIGURACION -->

    <ModalConfigPrograms
      :modalShow="modalShowPrograms"
      @closeModal="closeModalPrograms"
      :getListConfiguration="getListConfiguration"
      :isEdit="isEditConfig"
      :configurationForm="configurationForm"
      :isClone="isCloneConfig"
    />
  </div>
</template>

<script>

import { API_ROOT } from "../../Constants/Api";
import { AlertConfirm, AlertForm, ICON } from "../../helpers/Alert";
import ModalConfigPrograms from "./BussinessAndBranch/ModalConfigPrograms.vue";
import { ApiRequest } from '../../helpers/ApiRequest';
export default {
  name: "BussinessBranchAdmin",
  components: { ModalConfigPrograms },

  data: () => ({
    isLoadingBussinessList: false,
    itemsBussiness: [],
    filterBussiness: null,
    filterOn: [],
    checked: false,
    modalShowPrograms: false,
    isEditConfig: false,
    configurationForm: null,
    configRol: {},
    isCloneConfig: false,
  }),
  created() {
    this.configRol = this.$store.state.configRol;
    if (
      this.configRol.administrador.pestana.adminSucursales.permiso === false
    ) {
      this.$router.push({ name: "Welcome" });
      AlertForm(`${this.$i18n.t("permissions.unauthorized")} ${this.$i18n.t("admin.bussiness.title")}` , this.$i18n.t("permissions.validateAdmin"), ICON.WARNING, "center", null);
    }
  },
  async mounted() {
    await this.getListConfiguration();
  },
  computed: {
    fields() {
      return [
        {
          key: "nombre",
          label: this.$i18n.t("admin.bussiness.name"),
        },
        {
          key: "actions",
          label: this.$i18n.t("admin.role.actions"),
        },
      ];
    },
  },
  methods: {

    async getListConfiguration() {
      try {
        this.isLoadingBussinessList = true;
        let data = await ApiRequest.get(`${API_ROOT}pipelines/programas-score`);
        this.itemsBussiness = data.lista;
      } catch (err) {
        AlertForm(`Error Code: ${err.status}`, this.$i18n.t("permissions.errorPipelines"), ICON.ERROR);
      } finally {
        this.isLoadingBussinessList = false;
      }
    },

    
    deleteConfigProgram(id) {
      AlertConfirm(
        this.$i18n.t("admin.bussiness.msgDeleteProgram"),
        "",
        ICON.WARNING,
        () => this.confirmDelete(id)
      );
    },
    async confirmDelete(id) {
      try {
        await ApiRequest.delete(`${API_ROOT}pipelines/programas-score`, {id});
        AlertForm(this.$i18n.t("admin.bussiness.msgConfigRemoved"),
          "", ICON.SUCCESS);
        await this.getListConfiguration();
      } catch (err) {
        AlertForm(`Error Code: ${err.status}`, this.$i18n.t("admin.bussiness.errorDelete"), ICON.ERROR);
      }
    },
    

    newProgramConfiguration() {
      this.modalShowPrograms = true;
      this.configurationForm = null;
      this.isEditConfig = false;
      this.isCloneConfig = false;  
    },
    editConfigProgram(item) {
      this.modalShowPrograms = true;
      this.isEditConfig = true;
      this.isCloneConfig = false;
      this.configurationForm = item;
    },
    cloneConfigPrograms(item) {
      this.modalShowPrograms = true;
      this.isEditConfig = false;
      this.isCloneConfig = true;
      this.configurationForm = JSON.parse(JSON.stringify(item));
    },
    closeModalPrograms() {
      this.modalShowPrograms = false;
      this.configurationForm = null;
    },
    async changeStatus(item) {
      let formPrograms = {
          pais: item.pais === "Mx" ? 1:2,
          nombre: item.nombre,
          reglas_productos: item.configReglasProductos,
          productos: item.productos,
          id: item._id,
          estado: item.estado,
          reglas_pdf: item.reglas_pdf
        };
      try {
        await ApiRequest.put(`${API_ROOT}pipelines/programas-score`, formPrograms);
        AlertForm(this.$i18n.t("admin.bussiness.programsUpdate"), "", ICON.SUCCESS, "center");
        await this.getListConfiguration();
      } catch (err) {
        AlertForm(`Error Code: ${err.status}`, this.$i18n.t("admin.bussiness.errorUpdateProgram"), ICON.ERROR);
      }
    }
  },
};
</script>

<style>
</style>